import * as types from '../types.js';

export default {
    state: {
        currentModel: {},
        menuList: {
            loading: false
        },
        initial:{

        }
    },
    mutations: {
        [types.SET_MEGA_MENU_MODEL]: (state, payload) => {
            state.currentModel = Object.freeze(payload);
        },
        [types.SET_MEGA_MENU_LOADING]: (state, payload) => {
            state.menuList.loading = payload;
        }
    },
    actions: {
        [types.FETCH_MEGA_MENU_DATA]: ({ commit }, forcePreview) => (
            new Promise((resolve) => {
                commit(types.SET_MEGA_MENU_LOADING, true);
                DM.Service.MegaMenu.getData(forcePreview).then((data) => {
                    commit(types.SET_MEGA_MENU_MODEL, data);
                    commit(types.SET_MEGA_MENU_LOADING, false);
                    resolve(data);
                });
            })
        )
    }
};

